// Load third-party scripts asynchronously after user interaction
(function() {
  const loadAccessiBe = () => {
    const script = document.createElement('script');
    script.src = 'https://acsbapp.com/apps/app/dist/js/app.js';
    script.async = true;
    script.onload = function () {
      if (typeof acsbJS !== 'undefined') {
        acsbJS.init({
          statementLink: '',
          footerHtml: '',
          hideMobile: false,
          hideTrigger: false,
          disableBgProcess: false,
          language: 'en',
          position: 'left',
          leadColor: '#356648',
          triggerColor: '#5c5c5c',
          triggerRadius: '5px',
          triggerPositionX: 'left',
          triggerPositionY: 'bottom',
          triggerIcon: 'wheels',
          triggerSize: 'small',
          triggerOffsetX: 0,
          triggerOffsetY: 0,
          mobile: {
            triggerSize: 'small',
            triggerPositionX: 'left',
            triggerPositionY: 'bottom',
            triggerOffsetX: 10,
            triggerOffsetY: 10,
            triggerRadius: '50%',
          },
        });
      }
    };
    (document.head || document.body).appendChild(script);
  };

  // Load analytics and accessibility after page interaction or after 3 seconds
  let loaded = false;
  const loadRebuy = () => {
    const script = document.createElement('script');
    script.src = `https://cdn.rebuyengine.com/onsite/js/rebuy.js?shop=${window.Shopify?.shop || 'default'}`;
    script.async = true;
    document.head.appendChild(script);
  };

  const load = () => {
    if (!loaded) {
      loaded = true;
      loadAccessiBe();
      loadRebuy();
      
      // Load ALBSS analytics
      window.ALBSS = { event_key: '37b46d68-32d1-414e-aabf-59faea180283' };
      const albssScript = document.createElement('script');
      albssScript.src = "https://c.albss.com/p/l/loader.iife.js";
      albssScript.async = true;
      document.head.appendChild(albssScript);
    }
  };

  // Load on first user interaction
  ['mousedown', 'touchstart', 'scroll', 'keydown'].forEach(event => {
    document.addEventListener(event, load, { once: true, passive: true });
  });

  // Fallback: load after 3 seconds
  setTimeout(load, 3000);
})();

// Cart script functionality - filter selling plans
window.filterSellingPlans = (cart) => {
  console.log(cart)
  for(const item of cart.items) {
    const filteredSellingPlanGroups = item.product.selling_plan_groups.filter(
      ({ id }) => id != 'gid://shopify/SellingPlanGroup/4191223844'
    );

    const filteredPlansAllocations = item.product.selected_variant?.selling_plan_allocations?.filter(
      ({ selling_plan_group_id }) => selling_plan_group_id != 'gid://shopify/SellingPlanGroup/4191223844'
    );

    const filteredPlans = item.product.selected_variant?.selling_plans?.filter(
      ({ id }) => filteredPlansAllocations.find(({ selling_plan_id }) => selling_plan_id === id)
    );

    const frequencies = filteredSellingPlanGroups[0]?.selling_plans?.map(({ name }) => name );

    item.product.selling_plan_groups = filteredSellingPlanGroups;
    item.product.subscription_frequencies = frequencies;
    item.product.selected_variant.selling_plan_allocations = filteredPlansAllocations;
    item.product.selected_variant.selling_plans = filteredPlans;
    item.product.selected_variant.subscription_frequencies = frequencies;
  }
};

document.addEventListener('rebuy:cart.ready', event => {
  window.Rebuy.Cart.enrichCart(window.filterSellingPlans);
});

document.addEventListener('rebuy:cart.add', event => {
  window.Rebuy.util.wait(() => window.Rebuy.Cart.enrichCart(window.filterSellingPlans), 200);
});

document.addEventListener('rebuy:cart.change', event => {
  window.Rebuy.util.wait(() => window.Rebuy.Cart.enrichCart(window.filterSellingPlans), 200);
});

// Rebuy cart observer functionality
document.addEventListener('DOMContentLoaded', () => {
  let cartObserver = null;
  let isProcessing = false;
  
  // Cache DOM elements
  const domCache = {
    rebuyCart: null,
    flyoutItems: null
  };
  
  // Use RequestAnimationFrame instead of intervals for better performance
  function waitForElement(selector, callback, maxAttempts = 200) {
    let attempts = 0;
    
    function check() {
      const element = document.querySelector(selector);
      if (element) {
        callback(element);
        return;
      }
      
      attempts++;
      if (attempts < maxAttempts) {
        requestAnimationFrame(check);
      }
    }
    
    check();
  }
  
  // Initialize cart monitoring
  function initCartMonitoring() {
    waitForElement('#rebuy-cart', (targetNode) => {
      domCache.rebuyCart = targetNode;
      setupCartObserver(targetNode);
    });
  }
  
  function setupCartObserver(targetNode) {
    if (cartObserver) {
      cartObserver.disconnect();
    }
    
    const config = { 
      attributes: true, 
      attributeFilter: ['class'], // Only watch class changes
      attributeOldValue: true 
    };
    
    cartObserver = new MutationObserver((mutations) => {
      // Use requestAnimationFrame to defer processing
      requestAnimationFrame(() => handleCartVisibilityChange(mutations));
    });
    
    cartObserver.observe(targetNode, config);
  }
  
  function handleCartVisibilityChange(mutations) {
    if (isProcessing) return;
    
    for (const mutation of mutations) {
      if (mutation.attributeName === 'class') {
        const target = mutation.target;
        const classAdded = target.classList.contains('is-visible');
        const classWasPresent = mutation.oldValue?.includes('is-visible');
        
        if (classAdded && !classWasPresent) {
          isProcessing = true;
          initializeCartProducts();
          break;
        }
      }
    }
  }
  
  function initializeCartProducts() {
    waitForElement('.rebuy-cart__flyout-items', async (parentEle) => {
      try {
        domCache.flyoutItems = parentEle;
        
        // Use Promise.resolve to make this async and non-blocking
        await Promise.resolve().then(async () => {
          window.Loop = window.Loop || {};
          window.Loop.bundleCartAllItems = await getCartItems();
          hideAllButFirstOfEachBundle();
        });
      } catch (error) {
        console.error('Cart initialization error:', error);
      } finally {
        isProcessing = false;
      }
    });
  }
  
  function hideAllButFirstOfEachBundle() {
    const elementsWithBundleId = document.querySelectorAll('[class*="_bundleid:"]');
    const firstBundleItems = new Set();
    
    // Batch DOM operations
    const updates = [];
    
    elementsWithBundleId.forEach((element) => {
      const match = element.className.match(/_bundleid:([a-zA-Z0-9]+)/);
      if (match?.[1]) {
        const bundleId = match[1];
        if (!firstBundleItems.has(bundleId)) {
          firstBundleItems.add(bundleId);
          // Keep the first item visible (don't add to updates)
        } else {
          // Hide subsequent items with same bundle ID
          updates.push(element);
        }
      }
    });
    
    // Apply all style changes at once
    requestAnimationFrame(() => {
      updates.forEach(el => el.style.display = 'none');
      if (typeof initLoopBundle === 'function') {
        initLoopBundle('rebuy-cart__flyout-items');
      }
    });
  }
  
  // Cache cart data with timestamp
  let cartCache = { data: null, timestamp: 0 };
  const CACHE_DURATION = 2000; // 2 seconds
  
  async function getCartItems() {
    const now = Date.now();
    
    // Return cached data if still fresh
    if (cartCache.data && (now - cartCache.timestamp) < CACHE_DURATION) {
      return cartCache.data;
    }
    
    try {
      const response = await fetch('https://us.foursigmatic.com/cart.js');
      if (!response.ok) throw new Error('Cart fetch failed');
      
      const data = await response.json();
      const items = data?.items ?? [];
      
      // Update cache
      cartCache = { data: items, timestamp: now };
      return items;
    } catch (error) {
      console.error('Failed to fetch cart:', error);
      return cartCache.data ?? []; // Return cached data on error
    }
  }
  
  // Cleanup on page unload
  window.addEventListener('beforeunload', () => {
    if (cartObserver) {
      cartObserver.disconnect();
    }
  });
  
  // Start monitoring
  initCartMonitoring();
});

window.addEventListener('load', () => {
  window._learnq = window._learnq || [];
  
  function loadKlaviyo() {
    const s = document.createElement('script');
    s.src = 'https://static.klaviyo.com/onsite/js/a6ibCM/klaviyo.js?company_id=a6ibCM';
    s.defer = true;
    s.onload = () => {
      window.klaviyoLoaded = true;
      window.dispatchEvent(new CustomEvent('klaviyo:ready'));
    };
    s.onerror = () => console.warn('Klaviyo failed to load');
    document.head.appendChild(s);
  }
  
  requestIdleCallback?.(loadKlaviyo, { timeout: 2000 }) || setTimeout(loadKlaviyo, 1500);
});

// Klaviyo tracking for product pages - only run if on product template
if (window.template && window.template.includes('product')) {
  window.addEventListener('load', function() {
    let klAjax = true;
    let currentItem = null;
    
    function initKlaviyoTracking() {
      const _learnq = window._learnq || [];
      
      function addedToCart() {
        if (!klAjax) return;
        
        try {
          fetch(`${window.location.origin}/cart.js`)
            .then(res => {
              if (!res.ok) throw new Error('Cart fetch failed');
              return res.json();
            })
            .then(data => {
              const cart = {
                total_price: (data.total_price || 0) / 100,
                $value: (data.total_price || 0) / 100,
                total_discount: data.total_discount || 0,
                original_total_price: (data.original_total_price || 0) / 100,
                items: data.items || []
              };
              
              // Merge current item data if available
              if (currentItem) {
                Object.assign(cart, currentItem);
              }
              
              _learnq.push(['track', 'Added to Cart', cart]);
              klAjax = false;
              
              // Reset flag after delay to allow multiple tracking
              setTimeout(() => { klAjax = true; }, 1000);
            })
            .catch(err => console.warn('Klaviyo cart tracking failed:', err));
        } catch (err) {
          console.warn('Klaviyo tracking error:', err);
        }
      }
      
      // Override fetch to detect cart additions
      if (!window.fetchOverridden) {
        const originalFetch = window.fetch;
        window.fetch = function(...args) {
          const response = originalFetch.apply(this, args);
          
          response.then(res => {
            try {
              const url = res.url || (args[0] && args[0].toString());
              if (url && url.includes('/cart/add.js') && res.ok) {
                // Small delay to ensure cart is updated
                setTimeout(addedToCart, 100);
              }
            } catch (err) {
              console.warn('Fetch override error:', err);
            }
          }).catch(() => {}); // Silently handle promise rejections
          
          return response;
        };
        window.fetchOverridden = true;
      }
      
      // Track form submissions
      const atcButtons = document.querySelectorAll("form[action*='/cart/add'] button[type='submit']");
      atcButtons.forEach(button => {
        button.addEventListener("click", function(e) {
          try {
            const form = this.closest('form');
            if (form) {
              // Extract item data from form
              const formData = new FormData(form);
              const variantId = formData.get('id');
              const quantity = parseInt(formData.get('quantity')) || 1;
              
              if (variantId) {
                currentItem = {
                  variant_id: variantId,
                  quantity: quantity
                };
              }
            }
          } catch (err) {
            console.warn('Form data extraction failed:', err);
          }
        });
      });
    }
    
    // Initialize tracking when Klaviyo is ready
    if (window.klaviyoLoaded) {
      initKlaviyoTracking();
    } else {
      window.addEventListener('klaviyo:ready', initKlaviyoTracking, { once: true });
      // Fallback timeout
      setTimeout(() => {
        if (!window.klaviyoLoaded) {
          console.warn('Klaviyo timeout, initializing tracking anyway');
          initKlaviyoTracking();
        }
      }, 5000);
    }
  });
}
